import { createSelector } from 'reselect'

const getLiveViewer = (state: any) => state.liveViewers

/** A Redux selector to retrieve Live viewer Data
 * @param state - The Redux state
 * @param {object} - Live viewer Data.
 */

export const selectLiveViewer = createSelector(
  getLiveViewer,
  (data) => data && data.liveViewerData ? data.liveViewerData : null
)
